import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface IUserSessionState {
  isAuthenticated: boolean;
}

const initialState: IUserSessionState = {
  isAuthenticated: false,
};

export const userSessionSlice = createSlice({
  initialState,
  name: 'session',
  reducers: {
    setIsAuthenticated: (state, action: PayloadAction<boolean>) => {
      state.isAuthenticated = action.payload;
    },
  },
});

export const { setIsAuthenticated } = userSessionSlice.actions;
